// src/components/SkippedV2Badge.jsx — WAGON M (Lot M3.5)
//
// Pastille discrète signalant les réservations V2 NON facturées automatiquement
// pour un logement 'v2' × un mois donné (collectées par projectDataForFacturation
// dans skippedV2Ref). Au clic, déplie le détail : raison lisible + montants
// indicatifs + pré-remplissage ménage le cas échéant.
//
// RGPD : on affiche le voyageur (UI admin) — JAMAIS en console/log. Le ctx des
// skipped[] est volontairement SANS PII (ids + dates) ; le voyageur n'est PAS
// présent dans ctx. On n'affiche donc que des ids/dates/montants ici.
//
// Zéro skipped → le composant ne rend RIEN (l'appelant peut aussi court-circuiter).

import { useState } from "react"
import { DS } from "../lib/ui"

// Mapping reason → libellé lisible (FR). Toute reason inconnue → fallback neutre.
const REASON_LABELS = {
  cancelled_decision_manuelle: "Annulée — décision manuelle",
  statut_incoherent: "Statut incohérent — vérifier",
  montant_corrompu: "Montant illisible — vérifier",
  source_non_validee: "Source non validée — vérifier",
}

function reasonLabel(reason) {
  return REASON_LABELS[reason] || "Non facturée — vérifier"
}

// Formate une date ISO "YYYY-MM-DD" → "JJ/MM" (ou "—").
function fmtDate(iso) {
  if (!iso || typeof iso !== "string" || iso.length < 10) return "—"
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}`
}

export default function SkippedV2Badge({ skipped }) {
  const [open, setOpen] = useState(false)
  if (!Array.isArray(skipped) || skipped.length === 0) return null
  const n = skipped.length

  return (
    <span style={{ position: "relative", display: "inline-flex" }}>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o) }}
        title={`${n} réservation(s) non facturée(s) automatiquement — cliquer pour le détail`}
        style={{
          display: "inline-flex", alignItems: "center", gap: 4,
          background: "#fff3e0", color: "#a15c00",
          border: `1px solid ${DS.amber}55`, borderRadius: 12,
          padding: "1px 8px", fontSize: 10, fontWeight: 700,
          cursor: "pointer", fontFamily: DS.fontBody, whiteSpace: "nowrap",
        }}
      >
        ⚠️ {n} non facturée{n > 1 ? "s" : ""}
      </button>
      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute", top: "100%", left: 0, marginTop: 4, zIndex: 50,
            background: DS.white, border: `1px solid ${DS.border}`, borderRadius: 10,
            boxShadow: "0 4px 18px rgba(33,83,135,.18)", padding: 10,
            width: 300, fontFamily: DS.fontBody,
          }}
        >
          <div style={{ fontSize: 11, fontWeight: 700, color: DS.navy, marginBottom: 6 }}>
            {n} résa{n > 1 ? "s" : ""} non facturée{n > 1 ? "s" : ""} automatiquement
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: 260, overflowY: "auto" }}>
            {skipped.map((s, i) => {
              const ctx = s.ctx || {}
              const mi = s.montants_indicatifs || null
              return (
                <div key={i} style={{ borderTop: i > 0 ? `1px solid ${DS.border}` : "none", paddingTop: i > 0 ? 6 : 0 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#a15c00" }}>{reasonLabel(s.reason)}</div>
                  <div style={{ fontSize: 10, color: "#888", marginTop: 1 }}>
                    {(ctx.source || "—")} · {fmtDate(ctx.checkIn)} → {fmtDate(ctx.checkOut)}
                    {ctx.apiReference ? ` · ${ctx.apiReference}` : ""}
                  </div>
                  {mi && (
                    <div style={{ fontSize: 10, color: "#777", marginTop: 1 }}>
                      Indicatif : total {mi.total_amount != null ? `${mi.total_amount} €` : "—"}
                      {mi.ota_commission != null ? ` · comm. ${mi.ota_commission} €` : ""}
                      {mi.city_tax != null ? ` · taxe ${mi.city_tax} €` : ""}
                    </div>
                  )}
                  {s.menage_prefill != null && (
                    <div style={{ fontSize: 10, color: "#777", marginTop: 1 }}>
                      Ménage pré-rempli : {s.menage_prefill} €
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </span>
  )
}
